const module = { name: 'movie/shared/desktop/featuredShowtimeUI', exports: {} }; const exports = module.exports;



import { Fandango_util as Fandango_util_getLongDateString } from 'require-global';

const { getLongDateString } = Fandango_util_getLongDateString;


import { fd_url_manager as link } from 'require-core';



import { swig as swig } from 'require-core';



import { default as amenityFlyout } from 'swug-fdRequire-call:Fandango/amenityFlyout';



const Selectors = {
    SHOWTIMES_CONTAINER: '.js-movie-showtimes__container',
}
function getFirstElement(ary, defaultValue) {
    return Array.isArray(ary) && ary[0] || defaultValue;
}
function getAmenityGroup(variants) {
    const { amenityGroups } = getFirstElement(variants, {});
    return getFirstElement(amenityGroups, {});
}
function done(data) {
    const { movie, isPreSaleDesktopLegacy, selectedDate, showtimes: { theaterShowtimes, hasShowtimes } } = data;
    if (!theaterShowtimes || !hasShowtimes) {
        return;
    }
    const theater = getFirstElement(theaterShowtimes.theaters, {});
    const viewModel = {
        allShowtimesURI: link.mop({
            title: movie.sluggedTitle,
            id: movie.id
        }),
        amenityGroup: getAmenityGroup(theater.variants),
        date: getLongDateString(selectedDate),
        isPreSaleDesktopLegacy,
        theater
    };
    const markup = swig.render('_movieShowtimes', viewModel);
    const container = document.querySelector(Selectors.SHOWTIMES_CONTAINER);
    container && (container.outerHTML = markup);
    amenityFlyout.init();
}
module.exports = {
    done,
    error() { },
};
export default module.exports;